/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedextraparticipationconstraints3Inputs */

const en__field_inheritedextraparticipationconstraints3 = /** @type {(inputs: _Field_Inheritedextraparticipationconstraints3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participation Constraints (derived)`)
};

const de__field_inheritedextraparticipationconstraints3 = /** @type {(inputs: _Field_Inheritedextraparticipationconstraints3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedingungen für eine erfolgreiche Teilnahme (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "Participation Constraints (derived)" |
*
* @param {_Field_Inheritedextraparticipationconstraints3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedextraparticipationconstraints3 = /** @type {((inputs?: _Field_Inheritedextraparticipationconstraints3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedextraparticipationconstraints3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedextraparticipationconstraints3(inputs)
	return de__field_inheritedextraparticipationconstraints3(inputs)
});
export { _field_inheritedextraparticipationconstraints3 as "_field_inheritedExtraParticipationConstraints" }